import { createAction } from '@reduxjs/toolkit'
import type { Dispatch } from '@reduxjs/toolkit'
import { markSessionEnded } from 'api/auth/unauthorizedInterceptor'

import { detachRealtimeEventsClient } from '../../../realtime/BrowserRealtimeEventsClient'
import { invalidateUserLoad } from './loadUser'

export const sessionEnded = createAction('user/sessionEnded')

// Local cleanup only: receiving tabs must not call the logout endpoint,
// notify the legacy iframe, or broadcast another logout.
export default function endUserSession() {
    return (dispatch: Dispatch): void => {
        markSessionEnded()
        invalidateUserLoad()
        dispatch(sessionEnded())
        detachRealtimeEventsClient()

        if (window.Intercom) window.Intercom('shutdown')
    }
}
